class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.product-tabs__button');
    this.panels = this.querySelectorAll('.product-tabs__panel');
    this.mobileBreakpoint = 749;

    this.buttons.forEach(btn => {
      btn.addEventListener('click', () => this.activateTab(btn.dataset.tab));
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > this.mobileBreakpoint) {
        const activeBtn = this.querySelector('.product-tabs__button.is-active');
        if (activeBtn) this.activateTab(activeBtn.dataset.tab);
      }
    });

    this.initRezepteSlider();
  }

  initRezepteSlider() {
    const slider = this.querySelector('.product-tabs__rezepte-slider');
    if (!slider) return;

    const list = slider.querySelector('.product-tabs__rezepte-list');
    const prevBtn = slider.querySelector('.product-tabs__rezepte-nav--prev');
    const nextBtn = slider.querySelector('.product-tabs__rezepte-nav--next');
    if (!list || !prevBtn || !nextBtn) return;

    const scrollAmount = () => {
      const firstItem = list.querySelector('.product-tabs__rezept-item');
      if (!firstItem) return 240;
      const gap = parseFloat(getComputedStyle(list).gap) || 24;
      return firstItem.offsetWidth + gap;
    };

    prevBtn.addEventListener('click', () => {
      list.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      list.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    this.updateRezepteButtons = () => {
      const maxScroll = list.scrollWidth - list.clientWidth;
      if (maxScroll <= 1) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      }
      prevBtn.style.display = '';
      nextBtn.style.display = '';
      prevBtn.disabled = list.scrollLeft <= 0;
      nextBtn.disabled = list.scrollLeft >= maxScroll - 1;
    };

    list.addEventListener('scroll', this.updateRezepteButtons);
    window.addEventListener('resize', this.updateRezepteButtons);
    this.updateRezepteButtons();
  }

  activateTab(tabId) {
    this.buttons.forEach(b => {
      const active = b.dataset.tab === tabId;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', active);
    });
    this.panels.forEach(p => {
      if (p.dataset.tab === tabId) p.setAttribute('open', '');
      else p.removeAttribute('open');
    });
    if (tabId === 'rezepte' && this.updateRezepteButtons) {
      setTimeout(this.updateRezepteButtons, 50);
    }
  }
}
customElements.define('product-tabs', ProductTabs);